import React from 'react';
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import './DepoimentosSection.css'

export function DepoimentosSection() {
    return (
        <section className="testimonials-section-client">
            <div className="section-container-client">
                <h2 className="section-title-client">O que os tutores dizem</h2>

                <div className="testimonials-grid-client">
                    <Card className="testimonial-card-client">
                        <CardContent className="testimonial-card-content-client">
                            <div className="testimonial-stars-client">
                                {[...Array(5)].map((_, i) => (
                                    <span key={i} className="material-icon">star</span>
                                ))}
                            </div>
                            <p className="testimonial-text-client">
                                {"\"Finalmente consigo agendar banho pro meu cachorro sem precisar ligar. Muito mais pratico!\""}
                            </p>
                            <p className="testimonial-author-client">Maria Silva</p>
                            <p className="testimonial-pet-client">Tutora do Rex</p>
                        </CardContent>
                    </Card>

                    <Card className="testimonial-card-client">
                        <CardContent className="testimonial-card-content-client">
                            <div className="testimonial-stars-client">
                                {[...Array(5)].map((_, i) => (
                                    <span key={i} className="material-icon">star</span>
                                ))}
                            </div>
                            <p className="testimonial-text-client">
                                {"\"Adoro saber o preco antes. Sem surpresas na hora de pagar. Super recomendo!\""}
                            </p>
                            <p className="testimonial-author-client">Joao Santos</p>
                            <p className="testimonial-pet-client">Tutor da Luna</p>
                        </CardContent>
                    </Card>

                    <Card className="testimonial-card-client">
                        <CardContent className="testimonial-card-content-client">
                            <div className="testimonial-stars-client">
                                {[...Array(5)].map((_, i) => (
                                    <span key={i} className="material-icon">star</span>
                                ))}
                            </div>
                            <p className="testimonial-text-client">
                                {"\"Encontrei um pet shop otimo perto de casa. Meu pet adora e eu tambem!\""}
                            </p>
                            <p className="testimonial-author-client">Ana Costa</p>
                            <p className="testimonial-pet-client">Tutora do Bob</p>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </section>
    )
}